import { combineReducers } from 'redux'
import loginReducer, { passwordReducer, verifyOTPReducer } from './AuthReducers/LoginReducer'
import forgotPasswordReducer from './AuthReducers/ForgotPasswordReducer'
import logoutReducer from '../reducers/AuthReducers/LogoutReducer'
import {
  dietaryReportReducer,
    guestListReducer,
    guestNameListReducer,
    searchedGuestResult
} from '../reducers/GuestListReducers/GuestListReducer'
import {
    prelimAssessmentReducer,
    wellbeingReportReducer,
    preparatoryDietReducer,
    consultationNotesReducer,
    sessionReducer,
    guestDetailsReducer,
    testimonialReducer,
    programmeFeedbackReducer,
    getTeamMemberListReducer
} from '../reducers/GuestDataReducers/GuestDataReducer'

import {queryListReducer} from '../reducers/QueryReducrs/QueryReducr'
import {groupClassesAndActivityReducer} from '../reducers/GroupClassesAndActivityReducers/GroupClassesAndActivityReducer'
import {statusReportReducer} from '../reducers/StatusReportReducers/StatusReportReducer'
import { programReducer } from './ProgramReducers/ProgramReducer'
import { getUserManualListReducer } from './HelpReducers/HelpReducer'
import { recommendationsReducer } from './RecommendationsReducers/RecommendationsReducer'

const rootReducer = combineReducers ({
    loginReducer,
    passwordReducer,
    verifyOTPReducer,
    guestListReducer,
    guestNameListReducer,
    searchedGuestResult,
    logoutReducer,
    prelimAssessmentReducer,
    wellbeingReportReducer,
    preparatoryDietReducer,
    consultationNotesReducer,
    sessionReducer,
    guestDetailsReducer,
    queryListReducer,
    groupClassesAndActivityReducer,
    statusReportReducer,
    testimonialReducer,
    programmeFeedbackReducer,
    programReducer,
    forgotPasswordReducer,
    getUserManualListReducer,
    recommendationsReducer,
    dietaryReportReducer,
    getTeamMemberListReducer
})

export default rootReducer;